import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  drawer: {
    width: '100%'
  },
  drawerPaper: {
    width: '100%'
  },
  popper: {
    backgroundColor: '#FFF',
    paddingTop: 0,
    paddingBottom: 0,
    borderRadius: 10,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    '& .MuiAutocomplete-listbox': {
      paddingLeft: 40
    }
  },
  popperDivider: {
    backgroundColor: 'rgba(143,146,161,0.15)',
    height: '1px',
    marginTop: 0,
    marginBottom: 0
  },
  popperActionContainer: {
    paddingLeft: 0,
    paddingRigth: 0,
    textAlign: 'left',
    paddingBottom: 8
  },
  popperAction: {
    width: '100%',
    textAlign: 'left',
    justifyContent: 'flex-start',
    marginBottom: 0,
    paddingLeft: 56
  },
  searchInput: {
    color: theme.palette.text.primary,
    paddingLeft: '0!important'
    // padding: '8px 0 8px 15px',
    // '&::placeholder': {
    //   color: theme.palette.primary.main,
    //   opacity: 1
    // }
  },
  searchRoot: {
    backgroundColor: '#FFF',
    paddingTop: '5.5px!important',
    paddingBottom: '4.5px!important',
    paddingLeft: '0!important',
    marginBottom: 0,
    '& .MuiAutocomplete-popupIndicatorOpen': {
      transform: 'none'
    },
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottom: '1px solid rgba(143,146,161,0.15)'
  },
  searchNotchedOutline: {
    border: 'none',
    borderRadius: 10
  },
  option: {
    display: 'flex',
    alignItems: 'center'
  },
  optionIcon: {
    flexShrink: 0,
    width: 16,
    height: 16,
    marginRight: 8
  }
}))

export default useStyles
